import React from "react";
import PropTypes from "prop-types";
import objectFitImages from "object-fit-images";
import localforage from "localforage";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import ImagePreView from "@/react-components/ImagePreView";
import PopMask from "@/react-components/PopMask";

class AuthImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      image: "",
      imageUrl: "",
      show: false,
      showPopMask: false,
    };
  }

  componentDidMount() {
    this.getRealImage();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.src !== this.props.src) {
      this.getRealImage();
    }
  }

  getRealImage = () => {
    const { src, authentication } = this.props;
    const path = src.split("key=");
    if (path.length > 1) {
      const key = path[1];
      localforage
        .getItem(key)
        .then((value) => {
          if (value) {
            this.setState(
              {
                image: URL.createObjectURL(value),
              },
              () => {
                objectFitImages("img.auth-image");
              }
            );
          } else {
            api.image
              .getByKey({ key })
              .then((response) => {
                localforage.setItem(key, response).catch((error) => {
                  console.error(error);
                });
                this.setState(
                  {
                    image: URL.createObjectURL(response),
                  },
                  () => {
                    objectFitImages("img.auth-image");
                  }
                );
              })
              .catch((error) => {
                console.error("error: " + error.message);
              });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      let image = src;
      // if (authentication) {
      //   image = `${src}${src.indexOf("?") === -1 ? "?" : "&"}key=${
      //     authentication?.accountId
      //   }&token=${authentication?.token}`;
      // }
      this.setState(
        {
          image,
        },
        () => {
          objectFitImages("img.auth-image");
        }
      );
    }
  };

  previewImage() {
    this.showBigImg(this.state.image);
  }

  showBigImg(imgSrc) {
    this.setState({
      imageUrl: imgSrc,
      show: true,
      showPopMask: true,
    });
  }

  hideBigImg() {
    this.setState({
      imageUrl: "",
      show: false,
      showPopMask: false,
    });
  }

  render() {
    const { image, show, imageUrl } = this.state;
    const { isZoom, dispatch, ...rest } = this.props;

    return (
      <React.Fragment>
        {isZoom ? (
          <div>
            <img
              {...rest}
              className={`auth-image ${rest.className}`}
              src={image}
              onClick={this.previewImage.bind(this)}
              alt=""
              tabIndex="0"
            />
            <ImagePreView
              bigImgToggle={this.hideBigImg.bind(this)}
              maskClick={this.hideBigImg.bind(this)}
              show={show}
              src={imageUrl}
            />
            <PopMask maskClick={this.hideBigImg.bind(this)} show={show} />
          </div>
        ) : (
          <img
            {...rest}
            className={`auth-image ${rest.className}`}
            src={image}
            alt=""
          />
        )}
      </React.Fragment>
    );
  }
}

AuthImage.propTypes = {
  src: PropTypes.string,
  isZoom: PropTypes.bool,
};

AuthImage.defaultProps = {
  src: undefined,
  isZoom: true,
};

const mapStateToProps = (state) => {
  return {
    authentication: state?.user?.authentication,
  };
};

export default connect(mapStateToProps)(AuthImage);
